var exports = {
  "i": "boundaryContainer__piTck9",
};

module.exports = exports;
